<template>
  <div class="card mb-3">
    <div class="card-header bg-light">
      <h5 class="mb-0">Datos sobre el pago</h5>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-lg-6" v-if="showElement([1,3])">
          <div class="form-group">
            <label for="inputFilePayment">Documento probatorio del pago</label>
            <div class="custom-file">
              <input
                id="inputFilePayment"
                type="file"
                name="filePayment"
                class="custom-file-input"
                @change="$emit('file-change', $event)"
              />
              <label class="custom-file-label" for="inputFilePayment">
                {{ localResume?.payment_document_name || "Seleccione un archivo" }}
              </label>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label for="date">
              {{ isFormativeAction ? 'Fecha fin' : 'Fecha pago' }}
            </label>
            <input
              :value="localResume.date"
              @input="$emit('update:field', 'date', $event.target.value)"
              type="date"
              class="form-control"
              id="date"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaymentSection",
  props: {
    localResume: {
      type: Object,
      required: true,
    },
    isFormativeAction: {
      type: Boolean,
      default: false,
    },
    essay: {
      type: Object,
      default: () => ({}),
    },
    showElement: {
      type: Function,
      required: true,
    },
  },
};
</script>
